export const ROUTES = {
  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  OTP_VERIFY: "/otp-verify",
  NEW_PASSWORD: "/new-password",
  PASSWORD_SUCCESS: "/password-success",

  // Dashboard
  DASHBOARD: "/",
  TERM_AND_CONDITIONS: "/term-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",

  // Users
  USERS: "/settings/users",
  USER_DETAILS: "/user/:id",

  // Contacts
  CONTACTS: "/contacts",
  CONTACT_DETAILS: "/contact/:id",
  CONTACT_ACTION: "/contact/:id/:action",

  // Companies
  COMPANIES: "/companies",
  COMPANY_DETAILS: "/company/:id",

  // Properties
  PROPERTIES: "/properties",
  PROPERTY_DETAILS: "/property/:id",
  ADD_PROPERTY: "/add-property",
  EDIT_PROPERTY: "/edit-property/:id",

  // Buyers
  BUYERS: "/buyers",
  BUYER_DETAILS: "/buyer/:id",

  // Tasks
  TASKS: "/tasks",

  // Smart Plans
  TOUCH_PLANS: "/touch-plans",
  TOUCH_PLAN_DETAILS: "/touch-plan/:id",

  // Leads
  LEADS: "/leads",
  PIPELINE: "/pipeline",

  // Deals
  EXECUTED_LOI: "/executedloi",
  PROPOSALS: "/proposals",
  OFFERS: "/offers",
  EXCLUSIVES: "/exclusives",
  UNDER_CONTRACT: "/under-contract",
  CLOSED: "/closed",

  // Contract to Closed
  CONTACT_CLOSE: "/contact-close",
  ADD_CONTACT_CLOSE: "/add-contact-close",
  EDIT_CONTACT_CLOSE: "/edit-contact-close/:id",

  // Score Card
  SCORE_CARD: "/ScoreCard",
  SCORE_CARD_HISTORY: "/settings/ScoreCardHistory",
  ADD_SCORE_CARD: "/settings/add-scorcard",

  // Stages
  STAGE_DETAILS: "/stage_detail/:id",
  STAGE_DETAILS_ARCHIVE: "/stage_detail-Archive/:id",

  // Filter
  FILTER_DATA: "/FilterData/:id/:propertyId",

  // Demo
  PROPERTY_DEMO: "/propertydemo",

  // Settings
  SETTINGS: {
    PROFILE: "/settings/profile",
    CONTACT_ARCHIVE: "/settings/contact-archive",
    COMPANY_ARCHIVE: "/settings/company-archive",
    CONTRACT_TO_CLOSED_ARCHIVE: "/settings/Contract-to-closed-archive",
    LOGS: "/settings/Logs",
    PROPERTY_ARCHIVE: "/settings/property-archive",
    BUYER_ARCHIVE: "/settings/buyer-archive",
    EXECUTED_LOI_ARCHIVE: "/settings/executedloi-archive",
    EXCLUSIVE_ARCHIVE: "/settings/exclusive-archive",
    UNDER_CONTRACT_ARCHIVE: "/settings/undercontract-archive",
    CLOSED_ARCHIVE: "/settings/closed-archive",

    CONTACT_TAGS: "/settings/contact-tags",
    COMPANY_TAGS: "/settings/company-tags",
    LEAD_SOURCES: "/settings/lead-sources",
    LEAD_TYPE: "/settings/lead-type",
    LEAD_ROUND_ROBIN: "/settings/lead-round-robin",
    DESIGNATED_AGENTS: "/settings/designated-agents",
    PROPERTY_TYPES: "/settings/property-types",
    PROPERTY_TAGS: "/settings/property-tags",
    CONVERSION_RATE: "/settings/converstion-rate",
    TENANTS: "/settings/tenant",
    MAILCHIMP: "/settings/Mailchimp",
    CONNECTED_APP: "/settings/connected-app",
    SYSTEM_ALERTS: "/settings/system-alerts",
  },
};
